import React from 'react';
import { useRouter } from 'next/compat/router';
import { IrlEventSignup } from 'src/irl-events';
import { PageComponent } from 'src/types';
import ErrorPage from 'next/error';
import { EnterpriseLayout } from 'src/components/layouts/enterprise-layout';
import { withLayout } from 'src/components/layouts/with-layout';

const IrlEventSignUpPage: PageComponent = () => {
  const router = useRouter();

  const { params } = router?.query ?? {};
  const segmentCount = Array.isArray(params) ? params.length : 0;
  const isValidRoute = segmentCount === 2 || segmentCount === 3;

  if (!isValidRoute) {
    return <ErrorPage statusCode={404} />;
  }

  return <IrlEventSignup />;
};

export default withLayout(IrlEventSignUpPage, EnterpriseLayout);
